import React, { createContext, useState, useContext, useCallback } from 'react';
import { createPortal } from 'react-dom';

const AlertContext = createContext();

export const AlertProvider = ({ children }) => {
    const [alert, setAlert] = useState({ visible: false, titulo: '', mensaje: '', tipo: 'success' });

    const dispararAlerta = useCallback((titulo, mensaje, tipo = 'success') => {
        // Sonido opcional
        const audio = new Audio('https://assets.mixkit.co/active_storage/sfx/2013/2013-preview.mp3');
        audio.volume = 0.3;
        audio.play().catch(() => {});

        setAlert({ visible: true, titulo, mensaje, tipo });
        
        setTimeout(() => {
            setAlert(prev => ({ ...prev, visible: false }));
        }, 3500);
    }, []);

    return (
        <AlertContext.Provider value={dispararAlerta}>
            {children}
            {alert.visible && <GlobalToast alert={alert} />}
        </AlertContext.Provider>
    );
};

// Componente Visual que usa Portal para "flotar" sobre todo
const GlobalToast = ({ alert }) => {
    return createPortal(
        <div className="sh-global-container">
            <style>{`
                .sh-global-container {
                    position: fixed;
                    top: 30px;
                    left: 50%;
                    transform: translateX(-50%);
                    z-index: 100000; /* Por sobre todo */
                    pointer-events: none;
                }
                .sh-toast {
                    background: ${alert.tipo === 'success' ? '#28a745' : '#dc3545'};
                    color: white;
                    padding: 16px 28px;
                    border-radius: 50px;
                    display: flex;
                    align-items: center;
                    gap: 15px;
                    box-shadow: 0 10px 30px rgba(0,0,0,0.3);
                    animation: slideDown 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
                    min-width: 300px;
                }
                @keyframes slideDown {
                    0% { transform: translateY(-100px); opacity: 0; }
                    100% { transform: translateY(0); opacity: 1; }
                }
            `}</style>
            <div className="sh-toast">
                <i className={`fas ${alert.tipo === 'success' ? 'fa-check-circle' : 'fa-exclamation-circle'}`} style={{fontSize: '1.5rem'}}></i>
                <div>
                    <div style={{ fontWeight: 'bold', fontSize: '1.1rem' }}>{alert.titulo}</div>
                    <div style={{ opacity: 0.9, fontSize: '0.9rem' }}>{alert.mensaje}</div>
                </div>
            </div>
        </div>,
        document.body
    );
};

export const useAlert = () => useContext(AlertContext);